export enum RyderEnvironment {
  SANDBOX = "sandbox",
  PRODUCTION = "production",
}

export const RYDER_SANDBOX_URL = "https://sandbox.whiplash.app";
export const RYDER_PRODUCTION_URL = "https://app.getwhiplash.com";

export function ryderUrlForEnvironment(environment: RyderEnvironment): string {
  switch (environment) {
    case RyderEnvironment.SANDBOX:
      return RYDER_SANDBOX_URL;
    case RyderEnvironment.PRODUCTION:
      return RYDER_PRODUCTION_URL;
  }
}
